import { render, staticRenderFns } from "./RequiredPropertiesTooltip.vue?vue&type=template&id=0e4883ca&scoped=true&"
var script = {}
import style0 from "./RequiredPropertiesTooltip.vue?vue&type=style&index=0&id=0e4883ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4883ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
